// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  width: 100%;
  gap: 10px;
  font-size: 14px;
}
:host .hours-select-container,
:host .minutes-select-container {
  position: relative;
  flex: 0 0 calc(50% - 5px);
}
:host .hours-select-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
:host .hour-input-dropdown,
:host .minute-input-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}
:host .hour-input,
:host .minute-input {
  width: 50px;
  text-align: center;
}
:host .hour-input {
  text-indent: -999px;
}
:host .hour-input:focus {
  text-indent: 0;
}
:host .hour-input-show {
  text-indent: 0;
  background-color: white !important;
}
:host .hour-input-show.hours-focused {
  text-indent: -999px;
}
:host .minute-input {
  text-indent: -999px;
}
:host .minute-input:focus {
  text-indent: 0;
}
:host .minute-input-show {
  text-indent: 0;
  background-color: white !important;
}
:host .minute-input-show.minutes-focused {
  text-indent: -999px;
}
:host .hour-input-show,
:host .minute-input-show {
  position: absolute;
  pointer-events: none;
}
:host .hour-input,
:host .minute-input {
  position: relative;
  z-index: 9;
}
:host .selected-value {
  cursor: pointer;
}
:host .dst-indicator {
  min-height: 24px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
:host .dst-choice {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  padding: 0;
  line-height: 1;
  font-size: 14px;
  cursor: pointer;
}
:host .dst-choice.selected {
  border-color: #2e2f9d;
  box-shadow: inset 0 0 0 1px #2e2f9d;
}
:host .dst-fixed-emoji {
  font-size: 16px;
  line-height: 1;
}
:host .dst-invalid {
  min-height: 24px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #d64545;
  line-height: 1.2;
  text-align: center;
}
:host .options-container {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
}
:host .options-container.dropup {
  top: auto;
  bottom: 100%;
}
:host .selected-value {
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: transparent;
  width: 100%;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  padding: 8px 5px;
}
:host .selected-value.open {
  border-color: #007bff;
}
:host .options-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px; /* Optional, for scrollable dropdown */
  overflow-y: auto;
  border: 1px solid #ccc;
  border-top: none;
  background-color: white;
  z-index: 1000;
}
:host .hour-option,
:host .minute-option {
  padding: 8px 12px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
}
:host .hour-option:hover,
:host .minute-option:hover {
  background-color: #f0f0f0;
}
:host .hour-option.out-of-time,
:host .minute-option.out-of-time {
  background-color: #f9f9f9; /* Grey background for out-of-time */
  color: #999;
}
:host ::-webkit-scrollbar {
  width: 20px;
}
:host ::-webkit-scrollbar-track {
  background-color: transparent;
}
:host ::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}
:host ::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
